import { Spinner } from "@blueprintjs/core"
import React from "react"
import ReactTable from "react-table"
import { readableDate } from "utils/custom.utils"
import SerialColumn from "components/Organisms/table/SerialColumn"

const PaymentRecords = ({ contracts, loading }) => {
  if (loading) return <Spinner />

  const COLUMNS = [
    SerialColumn,
    {
      Header: "Payment Type",
      accessor: "paymentType",
      Cell({ value }) {
        return value?.name
      },
    },
    {
      accessor: "amount",
      Header: "Amount",
      Cell({ value }) {
        return `₹ ${value ?? 0}`
      },
    },
    {
      accessor: "paidTo.fullName",
      Header: "Paid To",
    },
    {
      accessor: "transactionType",
      Header: "Payment Method",
    },
    {
      accessor: "createdAt",
      Header: "Date",
      width: 150,
      Cell({ value }) {
        return readableDate(value)
      },
    },
  ]
  return (
    <ReactTable
      className="vt-schedule-table-new vt-expense-table"
      data={contracts}
      columns={COLUMNS}
      showPaginationBottom={false}
    />
  )
}

export default PaymentRecords
